import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Alert,
  Box,
} from "@mui/material";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import NotificationsIcon from "@mui/icons-material/Notifications";
import UpdateIcon from "@mui/icons-material/Update";

const OverviewTab = () => (
  <Card>
    <CardContent>
      <Typography variant="h5" gutterBottom>
        Welcome to Rituals Outlet Monitor
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        This service actively monitors the Rituals Outlet store for new product
        additions. It automatically detects new items and sends real-time
        notifications to Discord.
      </Typography>

      <Grid container spacing={3} mt={2}>
        <Grid item xs={12} md={4}>
          <Card variant="outlined" sx={{ height: "100%" }}>
            <CardContent sx={{ textAlign: "center" }}>
              <ShoppingBagIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">Outlet Monitoring</Typography>
              <Typography variant="body2" color="text.secondary">
                Scans https://www.rituals.com/de-de/outlet for product changes
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card variant="outlined" sx={{ height: "100%" }}>
            <CardContent sx={{ textAlign: "center" }}>
              <UpdateIcon color="warning" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">Cron Updates</Typography>
              <Typography variant="body2" color="text.secondary">
                Scheduled checks ensure timely detection of new inventory
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card variant="outlined" sx={{ height: "100%" }}>
            <CardContent sx={{ textAlign: "center" }}>
              <NotificationsIcon color="info" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">Discord Alerts</Typography>
              <Typography variant="body2" color="text.secondary">
                Sends instant notifications to your Discord channel for new
                items
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom>
        Service Configuration
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        To ensure the monitoring service runs effectively, please verify:
      </Typography>
      <Box component="ol" sx={{ pl: 3 }}>
        <li>
          <strong>Target URL:</strong> The monitor is configured for the German
          outlet store (de-de/outlet).
        </li>
        <li>
          <strong>Cron Schedule:</strong> Verify the cron job frequency settings
          in the Cronjobs tab to balance timeliness and server load.
        </li>
        <li>
          <strong>Discord Webhook:</strong> Ensure the Discord webhook URL is
          active and has permissions to post messages to the target channel.
        </li>
      </Box>

      <Alert severity="info" sx={{ mt: 3 }}>
        <Typography variant="body2">
          <strong>System Note:</strong> Detection speed depends on the
          configured cron schedule. Only significantly new items (not previously
          seen) will trigger a notification to avoid spam.
        </Typography>
      </Alert>
    </CardContent>
  </Card>
);

export default OverviewTab;
